import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const PosBank = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [securityData, setSecurityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    keyValue: "",
    description: "",
    securityObject: [],
    branchId: branchId
  });
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });

  const getGridData = async () => {
    const resp = await apiMethod.getPosProviders(filterModel.branchId, filterModel.size, filterModel.part, filterModel.title);
    if (methods.showApiErrors(resp)) {
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  useEffect(() => {
    if (formModel.securityObject && typeof formModel.securityObject === 'string' && formModel.securityObject.trim() != '') {
      try {
        const parsedSecurityData = JSON.parse(formModel.securityObject);
        setSecurityData(parsedSecurityData);
      } catch (error) {
        console.log(error);
      }
    }
  }, [formModel.securityObject]);

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getPosProviderInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.keyValue = resp.data.keyValue;
    formModel.description = resp.data.description;
    formModel.securityObject = resp.data.securityObject;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async () => {
    setLoading(true);

    try {
      const updatedPosProviderData = { ...formModel, securityObject: JSON.stringify(securityData) };
      const resp = await apiMethod.createPosProvider(updatedPosProviderData);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.keyValue = "";
    formModel.description = "";
    formModel.securityObject = [];
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const initialBankObject = async () => {
    setLoading(true);
    const resp = await apiMethod.initialPosProviders({
      id: 0,
      title: "",
      keyValue: "",
      description: "",
      securityObject: "",
      branchId: branchId
    });
    setLoading(false);
    if (methods.showApiErrors(resp))
      return false;

    getGridData();
  }

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removePosProvider(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const closeModal = () => {
    setShowFormModal(false);
    setShowDeleteModal(false);
  };

  const renderSecurityFields = () => {
    return securityData.map((group, index) => (
      <div className="accordion" id={`accordion-${index}`} key={group.GroupKey}>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="true"
              aria-controls={`collapse-${index}`}
            >
              {group.Title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse show"
            data-bs-parent={`#accordion-${index}`}
          >
            <div className="accordion-body">
              {group.Items.map((item) => (
                <div key={item.ItemKey} className='col-6 mb-2'>
                  <label htmlFor={item.ItemKey} className="form-label" id={item.ItemKey}>
                    {item.Title}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id={item.ItemKey}
                    value={item.ItemValue}
                    onChange={(e) =>
                      handleSecurityInputChange(
                        group.GroupKey,
                        item.ItemKey,
                        e.target.value
                      )
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const handleSecurityInputChange = (groupKey, itemKey, value) => {
    const updatedSecurityData = securityData.map((group) => {
      if (group.GroupKey === groupKey) {
        group.Items = group.Items.map((item) => {
          if (item.ItemKey === itemKey) {
            return { ...item, ItemValue: value };
          }
          return item;
        });
      }
      return group;
    });

    setSecurityData(updatedSecurityData);
  };

  const renderItems = () => {
    return (
      <>
        {loading ? <Preloading /> :
          <>
            <div className='d-none d-lg-flex justify-content-start align-items-baseline mb-3'>
              <Link to={`/sale/${branchId}/posDevices`} className='link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div className='d-md-flex justify-content-between align-items-baseline'>
                <Link to={`/sale/${branchId}/posDevices`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                دستگاه‌های پوز/بانک‌ها
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>دستگاه‌های پوز/بانک‌ها</p>
            </div>
            <div className="salemain">
              <div className='text-end'>
                <button
                  onClick={() => { initialBankObject() }}
                  className='btn btn-outline-purple custome-btn' type='button'>
                  <span className='align-middle d-inline-block'>بازیابی اولیه</span>
                </button>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-sm">
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">کلید</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{index + 1}</th>
                        <td>{item.title}</td>
                        <td>{item.keyValue}</td>
                        <td>
                          <button
                            onClick={() => editItem(item.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش سرویس دهنده پوز</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="ptitle" className="form-label">عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="ptitle"
                    name="ptitle"
                    value={formModel.title}
                    readOnly
                  />
                </div>
                {securityData && renderSecurityFields()}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50"
                onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeModal}
          deleteItem={deleteItem}
          text={'بانک'}
        />
      }
    </>
  );
}

export default PosBank;